import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState, useEffect, useCallback } from "react";
import { FormProvider, useForm, useFieldArray } from "react-hook-form";
import Button from "../../../../components/Common/Button/Button";
import Input from "../../../../components/Common/Input/Input";
import { createNewEvent } from "../../../../utils/mainTabs/events/createNewEvent";
import PlusIcon from "../../../../components/Common/SvgIcons/CommonIcons/PlusIcon";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
// import { EventTabs } from "./EventTabs/EventTabs";
import TabLinks from "../../../../components/Common/TabLinks/TabLinks";
import AddQuizAnswers from "./AddQuizAnswers/AddQuizAnswers";
import { FaSave } from "react-icons/fa";
import classes from "./EventAddQuiz.module.scss";
import SelectThumbnail from "../../../../containers/manage/CreateShotClass/SelectThumbnail/SelectThumbnail";
import { addQuizSchema } from "../../../../utils/mainTabs/events/eventSchema";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { events } from "../../../../utils/mainTabs/events/events";
import AddQuizQuestions from "./AddQuizQuestions/AddQuizQuestions";
import { useDispatch } from "react-redux";
import { createEventShotclassActionHandler } from "../../../../store/actions/actionHandlers/eventActionHandler";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import { updateEventShotclassActionHandler } from "../../../../store/actions/actionHandlers/eventActionHandler";
import { copyEventShotclassActionHandler } from "../../../../store/actions/actionHandlers/eventActionHandler";
import deleteQuizQuestion from "../../../../api/manage/deleteQuizQuestion";
import { FormattedMessage } from "react-intl";
import { eventPublishedByMe } from "../../../../utils/mainTabs/events/eventPublishedByMe";
// import { usePrompt } from "../../../../hooks/preventNavigationHook";

const EventAddQuiz = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
  const [activeThumbnailName, setActiveThumbnailName] = useState("");
  const [isImagesCheckbox, setIsImagesCheckbox] = useState(true);
  const [isEditQuestion, setIsEditQuestion] = useState(false);
  const [publishedEventLoader, setPublishedEventLoader] = useState(false);
  const [saveEventLoader, setSaveEventLoader] = useState(false);
  const [saveTrue, setSaveTrue] = useState(false);
  const [normalExit, setNormalExit] = useState(false);
  const [disableTabsOnValid, setDisableTabsOnValid] = useState(false);

  const {
    tenantName,
    formValues,
    initialFormState,
    setFormValues,
    setEventTiles,
    shotclassType,
    shotclassTypeFrom,
    eventPath,
    createNewEventPath,
  } = useOutletContext();
  const [quizInputVisible, setQuizInputVisible] = useState();
  const disabeldFieldsViewPath = location.pathname.includes(
    createNewEvent.viewpath(tenantName),
  );

  let answerTabs = [
    {
      id: 1,
      name: <FormattedMessage id="CREATE_MUTIPLECHOICE_TEXT" />,
      disabled:
        // ((shotclassType === "edit" || shotclassType === "copy") &&
        //   activeQuestionIndex <
        //     formValues?.Other?.AssessmentSet?.QuestionList?.length) ||
        // shotclassType === "view",
        isEditQuestion || disableTabsOnValid || formValues?.disableTabsOnValid,
    },
    {
      id: 2,
      name: <FormattedMessage id="CREATE_QUIZ_T&F_TEXT" />,
      disabled:
        // ((shotclassType === "edit" || shotclassType === "copy") &&
        //   activeQuestionIndex <
        //     formValues?.Other?.AssessmentSet?.QuestionList?.length) ||
        // shotclassType === "view",
        isEditQuestion || disableTabsOnValid || formValues?.disableTabsOnValid,
    },
  ];
  const methods = useForm({
    defaultValues: {
      ...formValues.addQuiz,
      ...formValues?.Other,
      // EnableTimer: formValues.addQuiz?.EnableTimer || false,
      // QuizDuration: formValues.addQuiz?.QuizDuration || null,
    },
    mode: "onChange",
    resolver: yupResolver(addQuizSchema),
  });
  const [activeSection, setActiveSection] = useState(1);
  const [activeTab, setActiveTab] = useState(1);
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    control,
    watch,
    trigger,
    reset,
    getValues,
    setValue,
    clearErrors,
  } = methods;
  const {
    fields: questionsFields,
    append: appendQuestion,
    remove: removeQuestion,
    move: moveQuestion,
    update: updateQuestion,
  } = useFieldArray({
    control,
    name: "QuestionsList",
  });
  const questionListWatch = watch("QuestionsList");
  const enableQuizTimeLimit = watch("EnableTimer");
  const globalQuizDuration = watch("QuizDuration");

  // Set default quiz duration to 0 when checkbox is unchecked
  useEffect(() => {
    if (!enableQuizTimeLimit && globalQuizDuration !== 0) {
      setValue("QuizDuration", 0);
    }
  }, [enableQuizTimeLimit, setValue, globalQuizDuration]);

  // Validation function for time limit
  const isTimeLimitValid = () => {
    // If it's live training, timer controls are not available, so validation always passes
    if (formValues.details.Tags === "livetraining") {
      return true;
    }

    // Get current values directly from watch
    const isTimeLimitEnabled = watch("EnableTimer");
    const duration = watch("QuizDuration");

    // If time limit checkbox is not checked, validation always passes
    if (!isTimeLimitEnabled) {
      return true;
    }
    // If time limit checkbox is checked, duration must be greater than 0 for publish button
    return duration && parseInt(duration) > 0;
  };

  const handleSetActiveTab = (id) => {
    // updateQuestion(activeQuestionIndex, {
    //   Question: questionListWatch?.[activeQuestionIndex]?.Question,
    //   QuestionImage: questionListWatch?.[activeQuestionIndex]?.QuestionImage,
    //   IsCorrect: questionListWatch?.[activeQuestionIndex]?.IsCorrect,
    //   AnswersList: questionListWatch?.[activeQuestionIndex]?.AnswersList,
    //   ActiveQuestionType: id,
    // });
    // setActiveTab(() => id);
    if (!isEditQuestion) {
      let updatedQuestion = {
        Question: questionListWatch?.[activeQuestionIndex]?.Question,
        QuestionImage: questionListWatch?.[activeQuestionIndex]?.QuestionImage,
        IsCorrect: "",
        ActiveQuestionType: id,
        MultiSelect: false,
        Explanation: "",
        Duration: 30,
        EnableTimer: false,
        QuizDuration: null,
        AnswersList: [
          { Answer: "", AnswerImage: "" },
          { Answer: "", AnswerImage: "" },
        ],
      };
      updateQuestion(
        activeQuestionIndex,
        //   {
        //   Question: questionListWatch?.[activeQuestionIndex]?.Question,
        //   QuestionImage: questionListWatch?.[activeQuestionIndex]?.QuestionImage,
        //   IsCorrect: questionListWatch?.[activeQuestionIndex]?.IsCorrect,
        //   AnswersList: questionListWatch?.[activeQuestionIndex]?.AnswersList,
        //   ActiveQuestionType: id,
        // }
        updatedQuestion,
      );
      setActiveTab(() => id);
    }
  };
  const addQuizCompleted = useCallback(
    (isCompleted) => {
      let updatedTiles = createNewEvent
        .tiles(navigate, location, params, tenantName)
        .map((tile) => {
          if (
            tile.path ===
            `${createNewEvent.path(location, params, tenantName)}/details`
          ) {
            return { ...tile, isCompleted: true };
          } else if (
            tile.path ===
            `${createNewEvent.path(location, params, tenantName)}/addQuiz`
          ) {
            return { ...tile, isCompleted: isCompleted };
          } else {
            return tile;
          }
        });
      debugger;
      setEventTiles(() => updatedTiles);
    },
    [
      formValues?.addSurvey?.TotalQuestionCount,
      navigate,
      location,
      setEventTiles,
    ],
  );
  useEffect(() => {
    if (formValues.details.Tags === "livetraining") {
      setQuizInputVisible(true);
    } else {
      setQuizInputVisible(false);
    }
    if (formValues?.addQuiz?.TotalQuestionCount > 0) {
      setActiveQuestionIndex(() => -1);
    } else {
      addQuizCompleted(false);
      setActiveQuestionIndex(() => 0);
    }
  }, [formValues?.addQuiz?.TotalQuestionCount, addQuizCompleted]);

  useEffect(() => {
    // debugger;
    if (formValues?.addQuiz?.QuestionsList?.length === 0) {
      reset(() => initialFormState.addQuiz);
      setFormValues((formValues) => {
        return {
          ...formValues,
          addQuiz: initialFormState.addQuiz,
        };
      });
    }
  }, [
    formValues?.addQuiz?.QuestionsList?.length,
    initialFormState.addQuiz,
    reset,
    setFormValues,
  ]);

  const saveQuestion = () => {
    if (shotclassType === "view") {
      setActiveQuestionIndex((_) => -1);
    } else {
      trigger().then(() => {
        console.log("Form validation result:", isValid);
        console.log("Form errors:", errors);
        if (isValid) {
          let quizData = getValues();
          quizData = {
            ...quizData,
            TotalQuestionCount: quizData.QuestionsList?.length,
          };
          setFormValues((formValues) => {
            return {
              ...formValues,
              addQuiz: {
                ...formValues.addQuiz,
                ...quizData,
              },
            };
          });
          setActiveQuestionIndex((_) => -1);
          setDisableTabsOnValid(true);
        } else {
          console.log("Validation failed, cannot save question");
        }
      });
      setIsEditQuestion(false);
    }
  };

  const previousNavigate = () => {
    let quizData = getValues();
    quizData = {
      ...quizData,
      TotalQuestionCount: quizData.QuestionsList?.length,
    };
    if (isValid && saveTrue) {
      setFormValues((formValues) => {
        return {
          ...formValues,
          addQuiz: {
            ...formValues.addQuiz,
            ...quizData,
          },
        };
      });
    }
    navigate(`${createNewEventPath}/details`);
  };

  const handleDrag = ({ source, destination }) => {
    if (destination) {
      moveQuestion(source.index, destination.index);
    }
  };
  const handleDeleteQuizQuestion = (index, questionId) => {
    if (questionId) {
      deleteQuizQuestion(questionId).then((data) => {
        console.log(data);
      });
    }

    removeQuestion(index);
    setActiveTab(1);
    let quizData = getValues();
    quizData = {
      ...quizData,
      QuizDuration: quizData.QuizDuration,
      TotalQuestionCount: quizData.QuestionsList?.length,
    };
    setFormValues((formValues) => {
      return {
        ...formValues,
        addQuiz: {
          ...formValues.addQuiz,
          ...quizData,
        },
      };
    });

    setIsEditQuestion(false);
    setDisableTabsOnValid(false);

    setFormValues((formValues) => {
      return {
        ...formValues,
        disableTabsOnValid: false,
      };
    });
    setActiveQuestionIndex((_) => -1);
  };
  const handleThumbnailSelect = (
    activeThumbnailName,
    isImagesCheckbox,
    activeSection = 2,
  ) => {
    setIsImagesCheckbox(isImagesCheckbox);
    setActiveThumbnailName(() => activeThumbnailName);
    setActiveSection(() => activeSection);
  };

  const submitData = (shotclassData) => {
    if (shotclassType === "copy") {
      dispatch(copyEventShotclassActionHandler(shotclassData)).then(() => {
        setPublishedEventLoader(false);
        navigate(eventPublishedByMe.path(tenantName));
      });
    } else if (shotclassType === "edit") {
      dispatch(updateEventShotclassActionHandler(shotclassData)).then(() => {
        setPublishedEventLoader(false);
        navigate(eventPublishedByMe.path(tenantName));
      });
    } else {
      dispatch(createEventShotclassActionHandler(shotclassData)).then(() => {
        setPublishedEventLoader(false);
        navigate(eventPublishedByMe.path(tenantName));
      });
    }
    dispatch(
      setErrorHandler(
        errorTypes.SUCCESS,
        "Event has been created successfully, You Can view same in Published By Me",
      ),
    );
  };
  const onSubmit = (data) => {
    setPublishedEventLoader(true);
    let shotclassData = {
      ...formValues,
      addQuiz: {
        ...formValues.addQuiz,
        ...data,
        TotalQuestionCount: data?.QuestionsList?.length,
        EnableTimer: data?.EnableTimer || false,
        QuizDuration: data?.QuizDuration || null,
      },
    };
    if (formValues?.addQuiz) {
      submitData(shotclassData);
    } else {
      setFormValues((formValues) => {
        return {
          ...formValues,
          addQuiz: {
            ...formValues.addQuiz,
            ...data,
            TotalQuestionCount: data?.QuestionsList?.length,
            EnableTimer: data?.EnableTimer || false,
            QuizDuration: data?.QuizDuration || null,
          },
        };
      });
      setPublishedEventLoader(false);
    }
  };
  useEffect(() => {
    if (activeTab) {
      reset();
    }
  }, []);
  const clearAll = useCallback(() => {
    // reset(() => initialFormState.addQuiz);
    // setFormValues((formValues) => {
    //   return {
    //     ...formValues,
    //     addQuiz: initialFormState.addQuiz,
    //   };
    // });
    // setActiveTab(1);
    // setActiveQuestionIndex(() => 0);
    // setIsEditQuestion(false);

    //mukesh code
    if (
      activeQuestionIndex >= 0 ||
      (activeQuestionIndex === 0 && questionListWatch.length > 1)
    ) {
      clearErrors(); // Clear all errors
      const updatedQuestions = questionsFields.map((field, index) => {
        if (index === activeQuestionIndex) {
          return {
            Question: "",
            QuestionImage: [{}],
            ActiveQuestionType: 1,
            // IsCorrect: "0",
            IsCorrect: "",
            // MultiSelect: false,
            Explanation: "",
            Duration: 30,
            EnableTimer: false,
            QuizDuration: null,
            AnswersList: [
              { Answer: "", AnswerImage: "" },
              { Answer: "", AnswerImage: "" },
            ],
          };
        }
        return field;
      });
      reset({ QuestionsList: updatedQuestions });
      setActiveTab(1);
      setIsEditQuestion(false);
      // setActiveQuestionIndex((_) => -1);
      setDisableTabsOnValid(false);

      setFormValues((formValues) => {
        return {
          ...formValues,
          disableTabsOnValid: false,
        };
      });
    }
    if (activeQuestionIndex === 0 && questionListWatch.length === 1) {
      reset(() => initialFormState.addQuiz);
      setFormValues((formValues) => {
        return {
          ...formValues,
          addQuiz: initialFormState.addQuiz,
        };
      });
      setActiveTab(1);
      setActiveQuestionIndex(() => 0);
      setIsEditQuestion(false);
    }
    // }, [initialFormState.addQuiz, reset, setFormValues]);

    //mukesh dependency
  }, [
    initialFormState.addQuiz,
    activeQuestionIndex,
    reset,
    clearErrors,
    questionsFields,
    setActiveTab,
    setIsEditQuestion,
    setActiveQuestionIndex,
  ]);

  const saveQuizDraft = () => {
    setSaveEventLoader(true);
    let quizData = getValues();
    if (activeQuestionIndex !== -1) {
      let questionsList = quizData.QuestionsList?.filter(
        (_, index) => index !== activeQuestionIndex,
      );
      quizData = {
        ...quizData,
        QuestionsList: questionsList,
        TotalQuestionCount: questionsList?.length,
      };
    } else {
      quizData = {
        ...quizData,
        TotalQuestionCount: quizData.QuestionsList?.length,
        EnableTimer: quizData?.EnableTimer || false,
        QuizDuration: quizData?.QuizDuration || null,
      };
    }
    let shotclassData = { ...formValues, addQuiz: quizData };
    if (shotclassType === "edit") {
      dispatch(updateEventShotclassActionHandler(shotclassData, "Saved")).then(
        () => {
          setSaveEventLoader(false);
          navigate(eventPath);
        },
      );
      dispatch(
        setErrorHandler(
          errorTypes.SUCCESS,
          "Event has been saved successfully, You Can view same in My Draft",
        ),
      );
      // navigate(events.path);
    } else if (shotclassType === "copy") {
      dispatch(copyEventShotclassActionHandler(shotclassData, "Saved")).then(
        () => {
          setSaveEventLoader(false);
          navigate(eventPath);
        },
      );
      dispatch(
        setErrorHandler(
          errorTypes.SUCCESS,
          "Event has been saved successfully, You Can view same in My Draft",
        ),
      );
    } else {
      dispatch(
        createEventShotclassActionHandler(
          shotclassData,
          "Saved",
          "LearningContentWithQuizAndSurvey",
        ),
      ).then(() => {
        setSaveEventLoader(false);
        navigate(eventPath);
      });
      dispatch(
        setErrorHandler(
          errorTypes.SUCCESS,
          "Event has been saved successfully, You Can view same in My Draft",
        ),
      );
    }
  };

  // useEffect(() => {
  //   if (isDirty) {
  //     setNormalExit(true);
  //   }
  // }, [setNormalExit, isDirty]);
  // usePrompt("Are you sure you want to leave this page?", normalExit);
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {activeSection === 1 ? (
          <div className={classes.addQuizMain}>
            <div className={classes.addQuizMain__innerDiv}>
              <div className={classes.addQuizMain__left}>
                <h1 className={classes.addQuizHeading}>
                  Add quiz with answers
                </h1>
                <div className={classes.inputUpload}>
                  <DragDropContext onDragEnd={handleDrag}>
                    <Droppable droppableId="quiz-questions">
                      {(provided, snapshot) => (
                        <AddQuizQuestions
                          errors={errors}
                          questionsFields={questionsFields}
                          questionListWatch={questionListWatch}
                          removeQuestion={removeQuestion}
                          activeQuestionIndex={activeQuestionIndex}
                          setActiveTab={setActiveTab}
                          setActiveQuestionIndex={setActiveQuestionIndex}
                          reference={provided.innerRef}
                          snapshot={snapshot}
                          shotclassType={shotclassType}
                          handleThumbnailSelect={handleThumbnailSelect}
                          isDistributed={formValues?.Other?.IsDistributed}
                          trigger={trigger}
                          isValid={isValid}
                          saveQuestion={saveQuestion}
                          setIsEditQuestion={setIsEditQuestion}
                          handleDeleteQuizQuestion={handleDeleteQuizQuestion}
                          {...provided.droppableProps}
                          disabeldFieldsViewPath={disabeldFieldsViewPath}
                          // isImagesCheckbox="true"
                        />
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
                {activeQuestionIndex === -1 ? (
                  !formValues?.Other?.IsDistributed ? (
                    <Button
                      label={"Add New Question"}
                      height="3"
                      width="17.9"
                      icon={PlusIcon}
                      onClick={() => {
                        appendQuestion({
                          Question: "",
                          QuestionImage: [],
                          IsCorrect: "",
                          ActiveQuestionType: 1,
                          Explanation: "",
                          Duration: 30,
                          EnableTimer: false,
                          QuizDuration: null,
                          AnswersList: [
                            { Answer: "", AnswerImage: "" },
                            { Answer: "", AnswerImage: "" },
                          ],
                        });
                        setActiveQuestionIndex(
                          () => questionsFields?.length || 0,
                        );
                        setIsEditQuestion(false);
                        setDisableTabsOnValid(false);

                        setFormValues((formValues) => {
                          return {
                            ...formValues,
                            disableTabsOnValid: false,
                          };
                        });
                        setActiveTab(() => 1);
                      }}
                      disabled={disabeldFieldsViewPath}
                      light
                      type="button"
                    />
                  ) : (
                    <></>
                  )
                ) : (
                  <Button
                    label={<FormattedMessage id="SAVE_TXT" />}
                    height="3"
                    width="15.9"
                    icon={FaSave}
                    onClick={() => {
                      saveQuestion();
                      setSaveTrue(true);
                    }}
                    light
                    type="button"
                    disabled={disabeldFieldsViewPath}
                  />
                )}
              </div>
              {activeQuestionIndex !== -1 && (
                <div className={classes.addQuizMain__right}>
                  <TabLinks
                    tabs={answerTabs}
                    activeTab={activeTab}
                    // setActiveTab={(id) => handleSetActiveTab(id)}
                    setActiveTab={(id) => {
                      clearErrors();
                      handleSetActiveTab(id);
                    }}
                  />
                  {questionsFields.map((_, questionIndex) => {
                    return questionIndex === activeQuestionIndex ? (
                      <AddQuizAnswers
                        key={_.id}
                        activeQuestionIndex={activeQuestionIndex}
                        control={control}
                        errors={errors}
                        activeTab={activeTab}
                        questionListWatch={questionListWatch}
                        shotclassType={shotclassType}
                        isDistributed={formValues?.Other?.IsDistributed}
                        quizInputVisible={quizInputVisible}
                        handleThumbnailSelect={handleThumbnailSelect}
                        disabeldFieldsViewPath={disabeldFieldsViewPath}
                        // isImagesCheckbox="false"
                        trigger={trigger}
                        setValue={setValue}
                      />
                    ) : (
                      <React.Fragment key={_.id}></React.Fragment>
                    );
                  })}{" "}
                </div>
              )}
            </div>
            <div className={classes.eventDetailsButtons}>
              <div className={classes.leftBtns}>
                <Button
                  label={<FormattedMessage id="PAGINATION_PREVIOUS" />}
                  small
                  dark
                  onClick={previousNavigate}
                />
                {formValues.details.Tags !== "livetraining" && (
                  <>
                    <div className={classes.timeLineControls}>
                      <Input
                        name="EnableTimer"
                        label={"Enable Time Limit"}
                        labelColor={"light"}
                        type="checkbox"
                        direction={"row"}
                        width="2"
                        disabled={disabeldFieldsViewPath}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setValue("EnableTimer", isChecked);

                          // If unchecking and there are questions, ensure publish button can be enabled
                          if (!isChecked) {
                            setValue("QuizDuration", 0);
                            // Trigger validation to update form state
                            if (formValues?.addQuiz?.TotalQuestionCount > 0) {
                              trigger();
                            }
                          }
                        }}
                      />
                    </div>
                    <div>
                      <Input
                        name="QuizDuration"
                        label="Total Quiz Duration (Sec)"
                        placeholder="0"
                        value={
                          watch("EnableTimer")
                            ? watch("QuizDuration") || ""
                            : "0"
                        }
                        labelColor={!watch("EnableTimer") ? "#e6e6e6" : "dark"}
                        direction="row"
                        maxLength="5"
                        width="8"
                        height="2"
                        disabled={!watch("EnableTimer")}
                        type="number"
                        error={errors?.QuizDuration?.message}
                        onChange={(e) => {
                          if (watch("EnableTimer")) {
                            setValue("QuizDuration", e.target.value);
                            // Trigger validation to show errors immediately
                            trigger("QuizDuration");
                          }
                        }}
                      />
                    </div>
                  </>
                )}
              </div>
              <div className={classes.rightBtns}>
                {
                  <>
                    {shotclassType === "create" && (
                      <div
                        className={classes.eventDetailsButtons_ClearAll}
                        onClick={() => {
                          clearAll();
                          //setNormalExit(false);
                        }}
                      >
                        <FormattedMessage id="CLEAR_ALL_TXT" />
                      </div>
                    )}
                    {/* {!disabeldFieldsViewPath && (
                      <div
                        className={classes.eventDetailsButtons_ClearAll}
                        onClick={clearAll}
                      >
                        <FormattedMessage id="CLEAR_ALL_TXT" />
                      </div>
                    )} */}
                    {shotclassType !== "view" &&
                      (shotclassType !== "edit" ||
                        (shotclassType === "edit" &&
                          shotclassTypeFrom === "myDrafts")) && (
                        <Button
                          label={<FormattedMessage id="SAVE_CLASS_TEXT" />}
                          small
                          dark
                          onClick={() => {
                            saveQuizDraft();
                            //setNormalExit(false);
                          }}
                          disabled={disabeldFieldsViewPath}
                          loading={saveEventLoader}
                        />
                      )}
                    {/* <Button
                      label="Save as Draft"
                      small
                      dark
                      disabled={!isValid}
                      onClick={saveQuizDraft}
                    /> */}
                  </>
                }
                <Button
                  label={<FormattedMessage id="CREATE_PUBLISH_TEXT" />}
                  small
                  dark
                  type={"submit"}
                  disabled={
                    !isValid ||
                    disabeldFieldsViewPath ||
                    formValues?.addQuiz.TotalQuestionCount < 1 ||
                    !isTimeLimitValid()
                  }
                  loading={publishedEventLoader}
                  //onClick={() => setNormalExit(false)}
                />
              </div>
            </div>
          </div>
        ) : activeSection === 2 ? (
          <SelectThumbnail
            setActiveSection={(val) => {
              setActiveSection(val);
              trigger([`QuestionsList.${activeQuestionIndex}.AnswersList`]);
            }}
            name={activeThumbnailName}
            isImagesCheckbox={isImagesCheckbox}
            questionListWatch={questionListWatch}
            selectedQuestionIndex={`${activeQuestionIndex + 1}`}
          />
        ) : (
          <></>
        )}
      </form>
    </FormProvider>
  );
};

export default EventAddQuiz;
